/* Complete Your Rig — bundle upsell. Theme asset (runs reliably, theme-origin). */
(function(){
  var TIERS = {
    '2.5': { rh: 47171168665771, lh: 47171168698539, price: 275, standalone: 375 },
    '3.0': { rh: 47171168731307, lh: 47171168764075, price: 295, standalone: 395 }
  };
  // Deluxe Series page rod-variant -> reel tier (auto-detect when no fixed tier on container)
  var ROD_TIER = {
    '45089251459243': '2.5', // Grande Ronde 3wt
    '44322760360107': '2.5', // Beaverhead 4wt
    '43869526687915': '2.5', // Gallatin 4wt
    '43869582983339': '3.0', // Henrys Fork 5wt
    '43869526720683': '3.0', // Deschutes 6wt
    '44998879477931': '3.0', // McKenzie 5wt
    '47156240449707': '3.0'  // Rogue 5wt
  };

  function init(root){
    if(root.getAttribute('data-cyr-init')) return;
    root.setAttribute('data-cyr-init','1');

    var fixed = root.getAttribute('data-tier'); // '2.5'/'3.0' for single-rod pages; null = detect
    var isFixed = !!(fixed && TIERS[fixed]);
    var outfitIds = (root.getAttribute('data-outfit-ids') || '').split(',').filter(Boolean);

    var btn = root.querySelector('.cyr-add'),
        main = root.querySelector('.cyr-main'),
        success = root.querySelector('.cyr-success'),
        errEl = root.querySelector('.cyr-error'),
        valEl = root.querySelector('.cyr-value'),
        saveEl = root.querySelector('.cyr-savings');
    if(!btn) return;

    var currentTier = isFixed ? fixed : '2.5';
    var rootDisplay = root.style.display || '';

    function selectedId(){
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if(m) return m[1];
      var sel = document.querySelectorAll('form[action*="/cart/add"] [name="id"], [name="id"]');
      for(var i=0;i<sel.length;i++){ if(sel[i].value) return sel[i].value; }
      return null;
    }

    function render(tier){
      currentTier = tier;
      var t = TIERS[tier];
      if(valEl) valEl.innerHTML = '$' + t.price + ' &middot; $100 less than buying it separately';
      if(saveEl) saveEl.textContent = 'At $' + t.price + ', that’s $100 less than the reel bundle on its own ($' + t.standalone + ').';
      if(!btn.disabled) btn.textContent = 'Add the bundle — $' + t.price;
    }

    function update(){
      var id = selectedId();
      // Detect-mode tier switching (Deluxe Series page)
      if(!isFixed && id && ROD_TIER[id] && ROD_TIER[id] !== currentTier) render(ROD_TIER[id]);
      // Hide the whole block when an Outfit variant is selected (it already includes the bundle)
      if(id && outfitIds.indexOf(String(id)) > -1){ root.style.display = 'none'; }
      else { root.style.display = rootDisplay; }
    }

    // initial render
    var id0 = selectedId();
    render(isFixed ? fixed : (id0 && ROD_TIER[id0] ? ROD_TIER[id0] : '2.5'));
    update();
    setInterval(update, 500); // track variant changes (tier + outfit hide) on every page

    btn.addEventListener('click', function(){
      var hand = root.querySelector('input[name="cyr-hand"]:checked');
      var t = TIERS[currentTier];
      var variantId = (hand && hand.value === 'left') ? t.lh : t.rh;
      btn.disabled = true; btn.textContent = 'Adding...';
      if(errEl) errEl.style.display = 'none';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_addon': 'complete-your-rig' } }] })
      })
      .then(function(r){ return r.json().then(function(b){ return { ok: r.ok, body: b }; }); })
      .then(function(res){
        if(res.ok){
          if(main) main.style.display = 'none';
          if(success) success.style.display = 'block';
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          btn.disabled = false; btn.textContent = 'Add the bundle — $' + TIERS[currentTier].price;
          if(errEl){ errEl.textContent = (res.body && res.body.description) ? res.body.description : 'Could not add the bundle. Please try again.'; errEl.style.display = 'block'; }
        }
      })
      .catch(function(){
        btn.disabled = false; btn.textContent = 'Add the bundle — $' + TIERS[currentTier].price;
        if(errEl){ errEl.textContent = 'Network error. Please try again.'; errEl.style.display = 'block'; }
      });
    });
  }

  function boot(){
    var els = document.querySelectorAll('.cyr-bundle');
    for(var i=0;i<els.length;i++) init(els[i]);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
